<sl-tooltip class="tooltip" hoist placement="bottom" trigger="click">
  <div [innerHTML]="content" class="tooltip-content" slot="content"></div>
  <div style="color: var(--my-toolbox-color-primary)">
    <sl-icon name="info-circle"></sl-icon>
  </div>
</sl-tooltip>
